<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_v">CONTENTS</a></p><a id="page_v">
</a><p class="toca"><a id="page_v"></a><a href="#/xhtml/06_Preface"><i>Preface</i></a></p>
<p class="tocb"><a href="#/xhtml/07_Acknowledgement"><i>Acknowledgments</i></a></p>
<p class="toca"><a href="#/xhtml/09_Introduction">Introduction</a></p>
<p class="toc">  <a href="#/xhtml/10_Chapter01">1.  Bartolomeo Cristofori</a></p>
<p class="toc">  <span href="#/xhtml/11_Chapter02" title="Link target outside of Sample">2.  Giving Cristofori’s <i>Nuovo Cimbalo</i> a Name: Terminology Problems throughout the Eighteenth Century</span></p>
<p class="toc">  <span href="#/xhtml/12_Chapter03" title="Link target outside of Sample">3.  Domenico Scarlatti</span></p>
<p class="toc">  <span href="#/xhtml/13_Chapter04" title="Link target outside of Sample">4.  New Inventions in Germany, <i>Pantalone</i> Instruments, and Gottfried Silbermann</span></p>
<p class="toc">  <span href="#/xhtml/14_Chapter05" title="Link target outside of Sample">5.  Johann Sebastian Bach and the “<i>Piano et Forte</i>”</span></p>
<p class="toc">  <span href="#/xhtml/15_Chapter06" title="Link target outside of Sample">6.  Pianoforte Builders in Germany around 1750</span></p>
<p class="toc">  <span href="#/xhtml/16_Chapter07" title="Link target outside of Sample">7.  The Generation of Bach’s Older Sons</span></p>
<p class="toc">  <span href="#/xhtml/17_Chapter08" title="Link target outside of Sample">8.  From Alberti, Platti, and Rutini to Eckard and the Younger Sons of Bach</span></p>
<p class="toc">  <span href="#/xhtml/18_Chapter09" title="Link target outside of Sample">9.  Developments in the Second Half of the Century: Johann Andreas Stein and Sébastien Erard</span></p>
<p class="toc"><span href="#/xhtml/19_Chapter10" title="Link target outside of Sample">10.  Joseph Haydn-Wenzel and Johann Schantz, Young Mozart and Nannette Stein</span></p>
<p class="toc"><span href="#/xhtml/20_Chapter11" title="Link target outside of Sample">11.  Anton Walter and Wolfgang Amadeus Mozart</span></p>
<p class="toc"><span href="#/xhtml/21_Chapter12" title="Link target outside of Sample">12.  From Broadwood, Merlin, and Clementi to Beethoven</span></p>
<p class="tocb"><span href="#/xhtml/22_Epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toca"><span href="#/xhtml/23_Appendix01" title="Link target outside of Sample"><i>Appendix: Scipione Maffei’s Article of 1711</i></span></p>
<p class="toca"><span href="#/xhtml/24_Bibliography" title="Link target outside of Sample"><i>Selected Bibliography</i></span></p>
<p class="toca"><span href="#/xhtml/25_Index01" title="Link target outside of Sample"><i>Index</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?2a5dbbcb